/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.bundle.js
Source: slb_src/v4/core/slb-entry.js
Build: slb_build/build.mjs
Built: 2026-09-19T16:53:53.040Z
Content-SHA256: c68eddc3fc459339fb47b513a4a6597c64ca52c874cebdadfd7f8b04789faa65
*/

(function(w){
  try{
    w.SLB = w.SLB || {};
    w.SLB.cfg = w.SLB.cfg || {};
    // Phase marker for the migration
    w.SLB.cfg.migrationPhase = w.SLB.cfg.migrationPhase || 5;
    // Safe-call helper so a single feature error won't blank the whole page
    w.SLB.safe = w.SLB.safe || function(fn, label){
      try{ return fn(); }
      catch(e){ try{ console.error('[SLB]', label || 'error', e); }catch(_e){} }
    };
    // DOM ready helper
    w.SLB.domReady = w.SLB.domReady || function(fn){
      try{
        if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
        else fn();
      }catch(e){ /* ignore */ }
    };
    // Page metadata (used in later phases)
    w.SLB.page = w.SLB.page || {};
    w.SLB.safe(function(){
      var b = document.body;
      if(!b) return;
      w.SLB.page.template = b.getAttribute('data-template') || (b.dataset ? b.dataset.template : '') || '';
      w.SLB.page.handle = b.getAttribute('data-handle') || (b.dataset ? b.dataset.handle : '') || '';
      w.SLB.page.path = (location && location.pathname) ? location.pathname : '';
    }, 'page-meta');

    // V4 request lifecycle owner.
    // A newer read can supersede an older read without teaching every feature its own
    // sequence counter. Direct fetches may also register a real cancel callback.
    // Backend Apps Script requests are not forcibly aborted after dispatch; instead,
    // stale completions become inert and must not mutate the newer view.
    (function(){
      if(w.SLB_REQUEST_LIFECYCLE) return;
      var slots = Object.create(null);
      var staleDrops = 0;
      var cancels = 0;
      function keyOf(v){ return String(v == null ? '' : v).trim(); }
      function cancelRecord(rec){
        if(!rec || typeof rec.cancel !== 'function') return;
        var fn = rec.cancel; rec.cancel = null;
        try{ fn(); cancels++; }catch(_e){}
      }
      function begin(key){
        key = keyOf(key);
        if(!key) return null;
        var prev = slots[key];
        if(prev) cancelRecord(prev);
        var id = prev ? (Number(prev.id||0) + 1) : 1;
        slots[key] = { id:id, cancel:null };
        return { key:key, id:id };
      }
      function current(token){
        if(!token || !token.key) return false;
        var rec = slots[String(token.key)];
        return !!(rec && Number(rec.id) === Number(token.id));
      }
      function setCancel(token, fn){
        if(!token || typeof fn !== 'function') return false;
        if(!current(token)){ try{ fn(); cancels++; }catch(_e){} return false; }
        slots[String(token.key)].cancel = fn;
        return true;
      }
      function invalidate(key){
        key = keyOf(key);
        if(!key) return;
        var prev = slots[key];
        if(prev) cancelRecord(prev);
        slots[key] = { id: prev ? (Number(prev.id||0) + 1) : 1, cancel:null };
      }
      function makeStale(token){
        var e = new Error('Superseded request ignored.');
        e.name = 'SLBStaleRequest';
        e.code = 'SLB_STALE_READ';
        e.silent = true;
        e.lifecycleKey = token && token.key ? String(token.key) : '';
        return e;
      }
      function guard(token, value){
        if(token && !current(token)){ staleDrops++; throw makeStale(token); }
        return value;
      }
      function isStale(err){ return !!(err && (err.code === 'SLB_STALE_READ' || err.name === 'SLBStaleRequest')); }
      function run(key, factory){
        var token = begin(key);
        var out;
        try{ out = factory(token); }catch(e){ return Promise.reject(e); }
        return Promise.resolve(out).then(function(v){ return guard(token, v); }, function(err){
          if(token && !current(token)){ staleDrops++; throw makeStale(token); }
          throw err;
        });
      }
      w.SLB_REQUEST_LIFECYCLE = {
        begin:begin,
        current:current,
        setCancel:setCancel,
        invalidate:invalidate,
        guard:guard,
        run:run,
        isStale:isStale,
        staleError:makeStale,
        stats:function(){ return { keys:Object.keys(slots).length, staleDrops:staleDrops, cancels:cancels }; }
      };
    })();

    // Phase 5: warn if generated runtime fails to load. Shopify can schedule the two
    // deferred assets on adjacent tasks, so allow the generated bundle one short turn.
    w.SLB.domReady(function(){
      setTimeout(function(){
        try{
          if(!w.SLB.__generatedLoaded){
            console.warn('[SLB] Generated bundle not loaded (assets/slb.bundle.generated.js). Site may be partially broken.');
          }
        }catch(_e){}
      }, 750);
    });

    // Immersive mode: hide the SLB hero row to free vertical space
    // Note: we only apply the hero-hide after the user is logged in (so the boot/login UI isn't blank).
    w.SLB.domReady(function(){
      try{
        // If the Liquid stub already provided a toggle (onclick), don't double-bind.
        try{ if(w.SLB && typeof w.SLB.toggleImmersive === 'function') return; }catch(_e){}
        var root = document.getElementById('SaamLawBank') || document.getElementById('tyWealthCourtyard');
        if(!root) return;
        var btn = document.getElementById('slbImmersiveIcon');
        if(!btn) return;

        var app = document.getElementById('tywApp');
        function isLoggedIn(){ return !!(app && !app.classList.contains('hidden')); }

        function paint(on){
          on = !!on;
          try{ btn.setAttribute('aria-pressed', on ? 'true' : 'false'); }catch(_e){}
          try{ btn.title = on ? 'Exit immersive mode' : 'Immersive mode'; }catch(_e){}
          try{ btn.textContent = on ? '🗗' : '⛶'; }catch(_e){}
        }

        function apply(on){
          on = !!on;
          // Only hide hero when logged in
          try{ root.classList.toggle('slbImmersive', on && isLoggedIn()); }catch(_e){}
          paint(on);
          try{ localStorage.setItem('slbImmersive', on ? '1' : '0'); }catch(_e){}
        }

        var saved = false;
        try{ saved = localStorage.getItem('slbImmersive') === '1'; }catch(_e){}
        paint(saved);

        // Apply immediately if already logged in; otherwise wait for login.
        if(saved && isLoggedIn()) apply(true);

        // Watch login state changes so saved immersive turns on after login.
        if(app && w.MutationObserver){
          var mo = new MutationObserver(function(){
            try{
              var want = false;
              try{ want = localStorage.getItem('slbImmersive') === '1'; }catch(_e){}
              if(want && isLoggedIn()) root.classList.add('slbImmersive');
              if(!want) root.classList.remove('slbImmersive');
            }catch(_e){}
          });
          mo.observe(app, { attributes:true, attributeFilter:['class'] });
        }

        btn.addEventListener('click', function(){
          var want = !(function(){ try{ return localStorage.getItem('slbImmersive') === '1'; }catch(_e){} return false; })();
          apply(want);
        });
      }catch(e){ try{ console.error('[SLB] immersive-toggle', e); }catch(_e){} }
    });

    // External links inside SLB dropdown menus (button.menuItem[data-href])
    // Open inside an embedded panel (instead of a new tab).
    w.SLB.domReady(function(){
      try{
        function closeDrops(){
          try{ document.querySelectorAll('.drop').forEach(function(d){ d.classList.add('hidden'); }); }catch(_e){}
          try{ document.querySelectorAll('.slbSub').forEach(function(d){ d.classList.add('hidden'); }); }catch(_e){}
          try{ var mp = document.getElementById('tywMobilePanel'); if(mp) mp.classList.add('hidden'); }catch(_e){}
        }

        function showPanelDirect(tab){
          try{
            document.querySelectorAll('[data-panel]').forEach(function(p){
              p.classList.toggle('hidden', p.getAttribute('data-panel') !== tab);
            });
          }catch(_e){}
          try{
            var now = document.getElementById('tywNowTab');
            if(now && tab === 'webView') now.textContent = 'Others';
          }catch(_e){}
        }

        function openEmbedded(url, title){
          if(!url) return;
          try{ closeDrops(); }catch(_e){}

          var requestLife = w.SLB_REQUEST_LIFECYCLE || null;
          var requestToken = requestLife && typeof requestLife.begin === 'function' ? requestLife.begin('slb:webview:content') : null;
          var requestAbort = null;
          try{
            if(requestToken && typeof AbortController !== 'undefined'){
              requestAbort = new AbortController();
              if(requestLife && typeof requestLife.setCancel === 'function') requestLife.setCancel(requestToken, function(){ try{ requestAbort.abort(); }catch(_eAbort){} });
            }
          }catch(_eAbortSetup){ requestAbort = null; }
          function requestIsCurrent(){ return !requestToken || !requestLife || typeof requestLife.current !== 'function' || requestLife.current(requestToken); }

          var panel = document.getElementById('slbWebViewPanel');
          var tEl = document.getElementById('slbWebViewTitle');
          var body = document.getElementById('slbWebViewBody');
          var openBtn = document.getElementById('slbWebOpenTabBtn');

          if(panel) panel.dataset.url = url;
          if(tEl) tEl.textContent = title || 'Others';
          if(openBtn) openBtn.dataset.url = url;

          if(body){
            try{ body.scrollTop = 0; }catch(_e){}
            body.innerHTML = '<div style="font-weight:900;">Loading…</div>';
          }

          // Prefer the built-in hash router when available.
          try{
            if(window.SLB_route && typeof window.SLB_route.hasTab === 'function' && window.SLB_route.hasTab('webView')){
              location.hash = '#webView';
            }else{
              // Still set hash for shareability, but force UI now.
              try{ location.hash = '#webView'; }catch(_e2){}
              showPanelDirect('webView');
            }
          }catch(_e){
            showPanelDirect('webView');
          }

          // Update the top tab label to match the opened item.
          try{
            var now = document.getElementById('tywNowTab');
            if(now) now.textContent = title || 'Others';
          }catch(_e){}

          // Load the Shopify page content as an embedded fragment.
          // Some pages (like BB BUDGET) are built with custom templates/sections, so `?view=slbpanel` can be empty.
          // Strategy:
          // 1) try `?view=slbpanel` (fast, header/footer-free) 2) if empty, fallback to normal URL and extract main content.

try{
  var rawUrl = url;
  var isBB = /\/pages\/bb-budget/i.test(String(rawUrl || ''));

  var toAbs = function(u){
    try{ return new URL(String(u||''), location.origin).toString(); }
    catch(e){ return String(u||''); }
  };

  var makeViewUrl = function(raw){
    try{
      var u = new URL(raw, location.origin);
      u.searchParams.set('view','slbpanel');
      return u.toString();
    }catch(e){
      if(String(raw).indexOf('?') >= 0) return raw + '&view=slbpanel';
      return raw + '?view=slbpanel';
    }
  };

  var pickBest = function(nodes){
    var best = null, bestScore = -1;
    (nodes || []).forEach(function(n){
      if(!n) return;
      var t = 0, e = 0;
      try{ t = (n.textContent ? String(n.textContent).replace(/\s+/g,'').length : 0); }catch(_e){}
      try{ e = (n.querySelectorAll ? n.querySelectorAll('*').length : 0); }catch(_e){}
      var score = t + Math.min(5000, e);
      if(score > bestScore){ bestScore = score; best = n; }
    });
    return best || (nodes && nodes[0]) || null;
  };

  var extractPack = function(html){
    var pack = { html:'', textLen:0, css:[], scripts:[], inline:[] };
    try{
      var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');

      // BB BUDGET uses the "blank" template and keeps the real app inside #tyBlankPage (hidden by default),
      // so we must extract the actual app root instead of the whole document.
      var main = null;
      if(isBB){
        try{
          main = doc.querySelector('#tyBudgetHub') || null;
          if(!main){
            var blank = doc.querySelector('#tyBlankPage');
            if(blank){
              try{ blank.classList.remove('ty-hidden'); }catch(_e){}
              main = blank.querySelector('#tyBudgetHub') || blank;
            }
          }
        }catch(_e){ main = null; }
      }
      if(!main){
        main = pickBest([
          doc.querySelector('main#MainContent'),
          doc.querySelector('#MainContent'),
          doc.querySelector('main'),
          doc.body
        ]) || doc.body;
      }

      // Remove duplicated BaseStation gate chrome if it got included.
      try{
        main.querySelectorAll('#rcoMenu,#rcoAdminMenu,.rcoMenu,.rcoAdminMenu').forEach(function(n){ n.remove(); });
      }catch(_e){}

      // For BB BUDGET: keep + execute page scripts (the "meat" is JS-driven).
      // For other pages: do NOT run scripts in-panel.
      if(isBB){
        // CSS (only budget-related)
        try{
          doc.querySelectorAll('link[rel="stylesheet"][href]').forEach(function(l){
            var h = l.getAttribute('href') || '';
            if(!h) return;
            if(!/bb|budget/i.test(h)) return;
            pack.css.push(toAbs(h));
          });
        }catch(_e){}

        // Scripts: load BB Budget bundles in correct order from the full document.
        // (The app HTML we extract usually does not contain the script tags.)
        try{
          doc.querySelectorAll('script[src]').forEach(function(s){
            var src = s.getAttribute('src') || '';
            if(!src) return;
            if(!/bb-budget/i.test(src)) return;
            pack.scripts.push(toAbs(src));
          });
        }catch(_e){}

        // Remove any scripts that got included in the extracted node (we'll re-run bundles after injecting).
        try{ if(main && main.querySelectorAll) main.querySelectorAll('script').forEach(function(s){ s.remove(); }); }catch(_e){}
      }else{
        // Strip scripts (no execution)
        try{ main.querySelectorAll('script').forEach(function(s){ s.remove(); }); }catch(_e){}
      }

      if(isBB && main && main.id === 'tyBudgetHub' && main.outerHTML){
        pack.html = main.outerHTML;
      }else{
        pack.html = (main && main.innerHTML) ? main.innerHTML : '';
      }
      pack.textLen = (main && main.textContent) ? String(main.textContent).replace(/\s+/g,'').length : 0;
    }catch(_e){
      pack.html = String(html || '');
      pack.textLen = pack.html.replace(/<[^>]+>/g,'').replace(/\s+/g,'').length;
    }
    return pack;
  };

  var ensureCss = function(arr){
    if(!isBB) return;
    (arr || []).forEach(function(href){
      if(!href) return;
      var abs = toAbs(href);
      if(!abs) return;
      try{
        if(document.querySelector('link[rel="stylesheet"][href="'+abs+'"]')) return;
      }catch(_e){}
      try{
        var ln = document.createElement('link');
        ln.rel = 'stylesheet';
        ln.href = abs;
        ln.dataset.slbweb = '1';
        document.head.appendChild(ln);
      }catch(_e){}
    });
  };

  var ensureScripts = function(arr){
    if(!isBB) return Promise.resolve();
    var seen = {};
    var list = [];
    (arr || []).forEach(function(src){
      src = toAbs(src);
      if(!src) return;
      if(seen[src]) return;
      seen[src] = 1;
      list.push(src);
    });

    var seq = Promise.resolve();
    list.forEach(function(src){
      seq = seq.then(function(){
        return new Promise(function(res){
          try{
            if(document.querySelector('script[src="'+src+'"]')) return res();
          }catch(_e){}
          try{
            var sc = document.createElement('script');
            sc.src = src;
            sc.async = false;
            sc.defer = false;
            sc.dataset.slbweb = '1';
            sc.onload = function(){ res(); };
            sc.onerror = function(){ res(); }; // don't block
            document.head.appendChild(sc);
          }catch(_e){ res(); }
        });
      });
    });
    return seq;
  };

  var runInline = function(arr){
    if(!isBB) return;
    (arr || []).forEach(function(code){
      if(!code) return;
      try{
        var sc = document.createElement('script');
        sc.dataset.slbweb = '1';
        sc.text = String(code);
        document.body.appendChild(sc);
        sc.remove();
      }catch(_e){}
    });
  };

  var loadOnce = function(fetchUrl){
    var fetchOpts = { credentials: 'include' };
    try{ if(requestAbort && requestAbort.signal) fetchOpts.signal = requestAbort.signal; }catch(_eSignal){}
    return fetch(fetchUrl, fetchOpts)
      .then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.text(); });
  };

  var viewUrl = makeViewUrl(url);

  loadOnce(viewUrl)
    .then(function(html){
      var out = extractPack(html);
      if(out.textLen < 40){
        // Fallback: load the real page template/sections.
        return loadOnce(rawUrl).then(function(html2){ return extractPack(html2); });
      }
      return out;
    })
    .then(function(out){
      if(!body || !requestIsCurrent()) return;
      body.innerHTML = out.html || '<div style="opacity:.8;">(Empty page)</div>';
      ensureCss(out.css);
      return ensureScripts(out.scripts).then(function(){ if(requestIsCurrent()) runInline(out.inline); });
    })
    .catch(function(err){
      if(!body || !requestIsCurrent()) return;
      try{ if(err && err.name === 'AbortError') return; }catch(_eAbortName){}
      var msg = (err && err.message) ? err.message : String(err || '');
      body.innerHTML =
        '<div style="font-weight:900;color:#b42318;">Cannot open inside SLB.</div>' +
        '<div style="margin-top:6px;opacity:.9;">' + msg + '</div>' +
        '<div style="margin-top:10px;">Use <b>Open in new tab</b> above if needed.</div>';
    });
          }catch(_e){
            if(body){
              body.innerHTML = '<div style="font-weight:900;color:#b42318;">Cannot open inside SLB.</div>';
            }
          }
        }

// Click handler for any menu button with data-href
        document.addEventListener('click', function(e){
          var t = e && e.target;
          if(!t || !t.closest) return;
          var btn = t.closest('.menuItem[data-href]');
          if(!btn) return;
          var url = btn.getAttribute('data-href');
          if(!url) return;
          var title = btn.getAttribute('data-webtitle') || (btn.textContent ? String(btn.textContent).trim() : '') || 'Others';
          try{ e.preventDefault(); }catch(_e){}
          try{ e.stopPropagation(); }catch(_e){}
          var uLower = String(url).toLowerCase();
          if(uLower.indexOf("/pages/tyd-lineage-library") !== -1 || uLower.indexOf("tyd-lineage-library") !== -1){
            try{ window.open(url, "_blank", "noopener,noreferrer"); }
            catch(_e){ try{ window.open(url, "_blank"); }catch(_e2){} }
            return;
          }
          if(uLower.indexOf("/pages/bb-budget") !== -1 || uLower.indexOf("bb-budget") !== -1){
            try{ window.open(url, "_blank", "noopener,noreferrer"); }
            catch(_e){
              try{ window.open(url, "_blank"); }
              catch(_e2){
                try{ location.href = url; }catch(_e3){}
              }
            }
            return;
          }
          openEmbedded(url, title);
        }, false);

        // Embedded panel buttons
        var backBtn = document.getElementById('slbWebBackBtn');
        if(backBtn && !backBtn.dataset.wired){
          backBtn.dataset.wired = '1';
          backBtn.addEventListener('click', function(){
            try{ if(w.SLB_REQUEST_LIFECYCLE && typeof w.SLB_REQUEST_LIFECYCLE.invalidate === 'function') w.SLB_REQUEST_LIFECYCLE.invalidate('slb:webview:content'); }catch(_eCancel){}
            try{
              // If there is meaningful history, go back.
              if(window.history && window.history.length > 1){
                window.history.back();
              }else{
                location.hash = '#overview';
                showPanelDirect('overview');
              }
            }catch(_e){
              try{ location.hash = '#overview'; }catch(_e2){}
              showPanelDirect('overview');
            }
          });
        }

        var openTabBtn = document.getElementById('slbWebOpenTabBtn');
        if(openTabBtn && !openTabBtn.dataset.wired){
          openTabBtn.dataset.wired = '1';
          openTabBtn.addEventListener('click', function(){
            var u = openTabBtn.dataset.url || '';
            if(!u){
              try{ var p = document.getElementById('slbWebViewPanel'); u = p ? (p.dataset.url || '') : ''; }catch(_e){}
            }
            if(!u) return;
            try{ window.open(u, '_blank', 'noopener,noreferrer'); }catch(_e){ try{ window.open(u, '_blank'); }catch(_e2){} }
          });
        }
      }catch(_e){}
    });
  }catch(_e){ /* ignore */ }
})(window);
